import { parseQueryParams } from 'utils';

export default function useQueryParams() {
  const params = parseQueryParams(window.location.search);
  return { search: window.location.search, location: window.location, params };
}
